<template>
  <div :class="classes">
    <div class="content">
      <c-button
        primary
        size="lg"
        icon="cross"
        class="btn-close"
        @click="close()"
      />
      <user-profile />
      <wallet-buttons
        v-if="$can('awards') || $can('cashback_tab') || $can('cashback_tab')"
        class="buttons"
        @close="close()"
      />

      <c-button
        v-if="!!(config || {}).has_request_partners"
        class="become-partner"
        size="lg"
        icon="certificate"
        @click="redirectAndClose()"
      >
        Seja parceiro
      </c-button>

      <layout-sidebar-item
        v-for="item in menuItems"
        class="item"
        arrow
        :key="item.name"
        :item="item"
        @click.native="close()"
      />

      <layout-sidebar-item
        v-if="(config.has_api_access && config.logout) || !config.has_api_access"
        class="logout"
        :item="logout"
        @click.native="logoutAction()"
      />
    </div>
  </div>
</template>

<script>
import { LAYOUT_PROFILE, LAYOUT_CLOSE, CONFIG_MAIN, AUTH, AUTH_LOGOUT, COIN, USER, ENGAGEMENT_BALANCE } from '@store/types'
import { mapGetters, mapActions } from 'vuex'
import UserProfile from '@components/User/UserProfile'
import LayoutSidebarItem from '@components/Layout/LayoutSidebarItem'
import WalletButtons from '@components/Layout/WalletButtons.vue'

export default {
  components: {
    UserProfile,
    LayoutSidebarItem,
    WalletButtons
  },

  data () {
    return {
      logout: {
        name: 'Sair',
        icon: 'exit-door-log-out2',
        path: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      opened: LAYOUT_PROFILE,
      config: CONFIG_MAIN,
      auth: AUTH,
      coin: COIN,
      engagementBalance: ENGAGEMENT_BALANCE,
      user: USER
    }),

    classes () {
      const classes = [
        'layout-sidebar', {
          '-opened': this.opened
        }]
      return classes
    },

    menuItems () {
      return [
        {
          name: 'Minhas informações',
          icon: 'user-profile',
          path: { name: 'Meu perfil' }
        },
        {
          name: 'Meus resgates',
          icon: 'receipt',
          path: { name: 'Resgates' }
        },
        {
          name: 'Meus favoritos',
          icon: 'bookmark',
          path: '/campanhas?favorites=true'
        },
        ...(
          this.$can('vidalink')
            ? [{
              name: 'Cartão farmácia',
              icon: 'windows-heart',
              path: '/cartao-farmacia?id=' + this.auth.token
            }]
            : []
        ),
        {
          name: 'Suporte',
          icon: 'question-circle',
          path: (this.config && this.config.support_link) || 'https://kaledo.zendesk.com/hc/pt-br',
          external: true
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      close: LAYOUT_CLOSE
    }),

    redirectAndClose () {
      this.$router.push({ name: 'Seja parceiro' })
      this.close()
    },

    logoutAction () {
      this.$store.dispatch(AUTH_LOGOUT)
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.layout-sidebar {
  background-color: #F8F8FD;
  z-index: 12;
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 300px;
  text-align: center;
  overflow: hidden;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  will-change: transform;
  display: flex;

  & > .content {
    flex: 100%;
    overflow-y: scroll;

    & > .become-partner {
      margin-bottom: 10px;
    }

    & > .btn-close {
      position: absolute;
      z-index: 15;
      left: 20px;
      top: 10px;
    }
    & > .reward-wallet {
      display: flex;
      justify-content: center;
      padding-bottom: 24px;
    }

    .buttons {
      width: 100%;
      max-width: 200px;
      margin: 0 auto;
      margin-bottom: 14px;
    }

    & > .item:not(:first-of-type) {
      border-top: 1px solid $border-color;
    }

    & > .logout { margin: 10px auto; }
  }

  &.-opened {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Layout/LayoutSidebar.vue